<template>
  <div v-if="clients" class="invoice-list">
    <div
      :id="'invoice-' + invoice.id"
      :class="'invoice ' + invoice.status + ' ' + ($route.params.id === invoice.id ? 'active' : '')"
      @click="clientInvoice ? selectClientInvoice(invoice) : selectInvoice(invoice)"
      v-for="invoice in invoices"
      :key="invoice.id">
      <div class="status-group">
        <span class="status">{{ invoice.status }}</span>
        <span v-if="overDue(invoice)" class="status over-due">over-due ({{overDueAmount(invoice)}})</span>
        <span v-if="invoice.unsaved" class="notification unsaved"> </span>
      </div>
      <div class="invoice-group">
        <div class="invoice-item number"> {{ invoice.number }}</div>
        <div class="invoice-item date">{{ moment(invoice.date).format('DD MMMM YYYY') }}</div>
      </div>
      <div class="invoice-group">
        <div class="invoice-item client"><span>{{ invoice.client_id ? clients.filter(c => c.id === invoice.client_id)[0].company : ''}}</span></div>
        <div class="invoice-item amount">{{ invoice.articles ? calculateTotal(invoice) : 0}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'invoice-list',
  props: ['invoices', 'clients', 'clientInvoice'],
  data () {
    return {
      moment: moment,
    }
  },
  computed: {},
  methods: {
    calculateTotal (invoice) {
      let total = 0
      for (let article of invoice.articles) {
        total += article.price_unit * article.quantity
      }
      total += (total / 100) * invoice.vat_percentage
      return +(Math.round(total + 'e+2') + 'e-2')
    },
    selectInvoice (invoice) {
      if(invoice !== this.$store.getters.selectedInvoice) {
        this.$store.dispatch('setSelectedInvoice', {invoice : invoice})
        this.$router.push({name: 'invoices-view', params: {id: invoice.id}})
      }
    },
    selectClientInvoice (invoice) {
      if(invoice !== this.$store.getters.selectedInvoice) {
        this.$store.dispatch('setSelectedClientInvoice', {invoice : invoice})
        this.$store.dispatch('setSelectedInvoice', {invoice : invoice})
        this.$router.push({name: 'clients-invoice-view', params: {invoiceId: invoice.id}})
      }
    },
    overDue(invoice) {
      return (moment() > moment(invoice.date).add(invoice.payment_period, 'd') && invoice.status === "pending")
    },
    overDueAmount(invoice) {
      return moment().diff(moment(invoice.date).add(invoice.payment_period, 'd'), "days")
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../../styles/colors";

@mixin statusColering($status, $color) {
  &.#{$status} {
    .status {
      background: $color;
    }
    &.active {
      background: rgba($color, 0.1);
      border: 1px solid rgba($color, 0.5);
    }
  }
}

.invoice-list {
  height: calc(100vh - 180px);
  overflow-y: scroll;
  overflow-x: hidden;
  margin: 0 10px;
  padding: 0 10px;
  border: 1px solid $color-border;
  border-radius: 4px;

  .invoice {
    max-width: 260px;
    position: relative;
    padding: 36px 8px 12px;
    margin: 10px 4px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    .status-group {
      width: 100%;
      font-size: 12px;
      font-weight: 500;
      position: absolute;
      top: 12px;
      .status {
        padding: 5px;
        border-radius: 3px;
        color: white;
        margin-right: 5px;
      }
      .notification {
        position: absolute;
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: $color-danger;
        right: 2px;
        top: 0;
      }
    }
    .invoice-group {
      &:first-of-type {
        margin-right: 16px;
      }
    }
    .invoice-item {

    }
    .number {
      font-size: 20px;
    }
    .date {
      font-size: 12px;
      font-weight: 700;
    }
    .client {
      text-align: right;
      font-size: 14px;
      width: 120px;
      white-space: nowrap;
      span {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .amount {
      text-align: right;
      &:after {
        content: "EUR";
        font-size: 10px;
        font-weight: 700;
        margin-left: 3px;
      }

    }
    &.active {
      background: rgba($default, 0.4);
    }
    @include statusColering('new', $new);
    @include statusColering('unsend', $unsend);
    @include statusColering('pending', $pending);
    @include statusColering('incompletely', $incompletely);
    @include statusColering('payed', $payed);

    &.pending .status-group .status.over-due {
      background: $color-danger;
    }

  }
  &::-webkit-scrollbar {
    width: 12px;
  }
  &::-webkit-scrollbar-thumb {
    cursor: pointer;
    background: #ccc;
  }
  &::-webkit-scrollbar-track-piece {
    background: white;
  }
}


@media print {
  .invoice-list {
    display: none;
  }
}
</style>
